import React, { useState } from "react";
import {
  BasicCandidateIcon,
  CandidateDocumentIcon,
  HiringIntialIcon,
  UploadFileIcon,
} from "../../../../assets/images";
import "./style.scss";
import { ToggleSwitch } from "../../../commons";
import HiringCheckListAttachmentUpload from "./HiringCheckListAttachmentUpload";
type AppProps = {
  hiringCheckListData: any;
  handleToggleAllItems: (name: string) => void;
  handleICAIIntimation: (e: string) => void;
  uploadFetching:boolean;
  uploadFiles:any
  files:any;
  handleDeleteUploadedFile:(data:any)=>void;
  handleFileChange:(data:React.ChangeEvent<HTMLInputElement>)=>void;
  fileInputRef:any;
  handleFileClick:()=>void;
};
const CandidateData = ({
  hiringCheckListData,
  handleToggleAllItems,
  handleICAIIntimation,
  uploadFetching,
  uploadFiles,
  files,
  handleDeleteUploadedFile,
  handleFileChange,
  fileInputRef,
  handleFileClick,
}: AppProps) => {

  return (
    <>
      <div className="hiring-card border">
        <div className="hiring-header">
          <img src={HiringIntialIcon} alt="sheet" />
          <span className="hiringInitial hiring-header-card">
            Hiring Initial Setup
          </span>
        </div>
        <div className=" pt-3 pl-3 pr-4 pb-0">
          <div className="hiring-questions-main">
            <div className="hiring-questions pt-3 pb-3">
              Comp Discussed and Accepted on Email?
            </div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() =>
                  handleToggleAllItems("compDiscussedAndAccepted")
                }
                name={"compDiscussedAndAccepted"}
                isChecked={hiringCheckListData?.compDiscussedAndAccepted}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.compDiscussedAndAccepted == false
                  ? "No "
                  : "Yes"}
              </span>
            </div>
          </div>

          <div className="hiring-questions-main">
            <div className="hiring-questions pt-3 pb-3">
              Within 30 Days Completed Background Check{" "}
            </div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() =>
                  handleToggleAllItems("within30DaysCompletedBackgroundCheck")
                }
                name={"within30DaysCompletedBackgroundCheck"}
                isChecked={
                  hiringCheckListData?.within30DaysCompletedBackgroundCheck
                }
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.within30DaysCompletedBackgroundCheck ==
                false
                  ? "No "
                  : "Yes"}
              </span>
            </div>
          </div>

          <div className="hiring-questions-main">
            <div className="hiring-questions pt-3 pb-3">
              Offer Letter Signature{" "}
            </div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() =>
                  handleToggleAllItems("offerLetterSignature")
                }
                name={"offerLetterSignature"}
                isChecked={hiringCheckListData?.offerLetterSignature}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.offerLetterSignature == false
                  ? "No "
                  : "Yes"}
              </span>
            </div>
          </div>

          <div className="hiring-questions-main">
            <div className="hiring-questions pt-3 pb-3">Documentation </div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() => handleToggleAllItems("documentation")}
                name={"documentation"}
                isChecked={hiringCheckListData?.documentation}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.documentation == false ? "No " : "Yes"}
              </span>
            </div>
          </div>

          <div
            className="hiring-questions-main"
            style={{ borderBottom: "none" }}
          >
            <div className="hiring-questions pt-3 pb-3">
              Reference Call Feedback Received Before Confirming Joining Date?{" "}
            </div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() =>
                  handleToggleAllItems("referenceCallFeedbackReceived")
                }
                name={"referenceCallFeedbackReceived"}
                isChecked={hiringCheckListData?.referenceCallFeedbackReceived}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.referenceCallFeedbackReceived == false
                  ? "No "
                  : "Yes"}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="hiring-card border">
        <div className="hiring-header">
          <img src={CandidateDocumentIcon} alt="sheet" />
          <span className="candidateDocumentation hiring-header-card">
            Candidate Documents
          </span>
        </div>
        <div className=" pt-3 pl-3 pr-4 pb-0">
          <div className="hiring-questions-main">
            <div className="hiring-questions pt-3 pb-3">
              Pass Book/Bank Statement (3 months) Xerox
            </div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() =>
                  handleToggleAllItems("passBookBankXerox")
                }
                name={"passBookBankXerox"}
                isChecked={hiringCheckListData?.passBookBankXerox}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.passBookBankXerox == false ? "No " : "Yes"}
              </span>
            </div>
          </div>

          <div className="hiring-questions-main">
            <div className="hiring-questions pt-3 pb-3">Payslip (2 months)</div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() => handleToggleAllItems("payslip")}
                name={"payslip"}
                isChecked={hiringCheckListData?.payslip}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.payslip == false ? "No " : "Yes"}
              </span>
            </div>
          </div>

          <div className="hiring-questions-main">
            <div className="hiring-questions pt-3 pb-3">
              Appointment Letter (Previous Organisation)
            </div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() =>
                  handleToggleAllItems("appointmentLetter")
                }
                name={"appointmentLetter"}
                isChecked={hiringCheckListData?.appointmentLetter}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.appointmentLetter == false ? "No " : "Yes"}
              </span>
            </div>
          </div>

          <div className="hiring-questions-main">
            <div className="hiring-questions pt-3 pb-3">Income Tax Return </div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() =>
                  handleToggleAllItems("incomeTaxReturn")
                }
                name={"incomeTaxReturn"}
                isChecked={hiringCheckListData?.incomeTaxReturn}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.incomeTaxReturn == false ? "No " : "Yes"}
              </span>
            </div>
          </div>

          <div
            className="hiring-questions-main"
            // style={{ borderBottom: "none" }}
          >
            <div className="hiring-questions pt-3 pb-3">
              Offer Letter (Previous Organisation)
            </div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() => handleToggleAllItems("offerLetter")}
                name={"offerLetter"}
                isChecked={hiringCheckListData?.offerLetter}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.offerLetter == false ? "No " : "Yes"}
              </span>
            </div>
          </div>
          {/*  */}
          <div
            className="hiring-questions-main"
            // style={{ borderBottom: "none" }}
          >
            <div className="hiring-questions pt-3 pb-3">
              Relieving Letter (Previous Organisation)
            </div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() =>
                  handleToggleAllItems("relievingLetter")
                }
                name={"relievingLetter"}
                isChecked={hiringCheckListData?.relievingLetter}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.relievingLetter == false ? "No " : "Yes"}
              </span>
            </div>
          </div>
          {/*  */}
          <div
            className="hiring-questions-main"
            // style={{ borderBottom: "none" }}
          >
            <div className="hiring-questions pt-3 pb-3">
              Experience Letter (Previous Organisation)
            </div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() =>
                  handleToggleAllItems("experienceLetter")
                }
                name={"experienceLetter"}
                isChecked={hiringCheckListData?.experienceLetter}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.experienceLetter == false ? "No " : "Yes"}
              </span>
            </div>
          </div>
          <div
            className="hiring-questions-main"
            style={{ borderBottom: "none" }}
          >
            <div className="hiring-questions pt-3 pb-3">ICAI Intimation</div>
            <div className="questions-toggle pt-3 pb-3">
              <input
                type="text"
                name="iCAIIntimation"
                value={hiringCheckListData?.iCAIIntimation}
                onChange={(e: any) => handleICAIIntimation(e)}
              />
            </div>
          </div>
        </div>
      </div>
      {/*  */}
      <div className="hiring-card border">
        <div className="hiring-header">
          <img src={BasicCandidateIcon} alt="sheet" />
          <span className="basicCandidate hiring-header-card">
            Candidate Basic Setup
          </span>
        </div>
        <div className=" pt-3 pl-3 pr-4 pb-0">
          <div className="hiring-questions-main">
            <div className="hiring-questions pt-3 pb-3">
              Filing up HRIS Form and Laptop Form
            </div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() =>
                  handleToggleAllItems("filingUpHRISFormAndLaptopForm")
                }
                name={"filingUpHRISFormAndLaptopForm"}
                isChecked={hiringCheckListData?.filingUpHRISFormAndLaptopForm}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.filingUpHRISFormAndLaptopForm == false
                  ? "No "
                  : "Yes"}
              </span>
            </div>
          </div>

          <div className="hiring-questions-main">
            <div className="hiring-questions pt-3 pb-3">Finac Knowledge</div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() =>
                  handleToggleAllItems("finacKnowledge")
                }
                name={"finacKnowledge"}
                isChecked={hiringCheckListData?.finacKnowledge}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.finacKnowledge == false ? "No " : "Yes"}
              </span>
            </div>
          </div>

          <div className="hiring-questions-main">
            <div className="hiring-questions pt-3 pb-3">Holiday List</div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() => handleToggleAllItems("holidayList")}
                name={"holidayList"}
                isChecked={hiringCheckListData?.holidayList}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.holidayList == false ? "No " : "Yes"}
              </span>
            </div>
          </div>

          <div className="hiring-questions-main">
            <div className="hiring-questions pt-3 pb-3">HR Policies </div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() => handleToggleAllItems("hRPolicies")}
                name={"hRPolicies"}
                isChecked={hiringCheckListData?.hRPolicies}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.hRPolicies == false ? "No " : "Yes"}
              </span>
            </div>
          </div>

          <div
            className="hiring-questions-main"
            // style={{ borderBottom: "none" }}
          >
            <div className="hiring-questions pt-3 pb-3">PTO Tool</div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() => handleToggleAllItems("ptoTool")}
                name={"ptoTool"}
                isChecked={hiringCheckListData?.ptoTool}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.ptoTool == false ? "No " : "Yes"}
              </span>
            </div>
          </div>
          {/*  */}
          <div
            className="hiring-questions-main"
            // style={{ borderBottom: "none" }}
          >
            <div className="hiring-questions pt-3 pb-3">Stationary Items</div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() =>
                  handleToggleAllItems("stationaryItems")
                }
                name={"stationaryItems"}
                isChecked={hiringCheckListData?.stationaryItems}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.stationaryItems == false ? "No " : "Yes"}
              </span>
            </div>
          </div>
          {/*  */}
          <div
            className="hiring-questions-main"
            // style={{ borderBottom: "none" }}
          >
            <div className="hiring-questions pt-3 pb-3">Email ID Creation</div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() =>
                  handleToggleAllItems("emailIDCreation")
                }
                name={"emailIDCreation"}
                isChecked={hiringCheckListData?.emailIDCreation}
              />
              <span style={{width:'24px'}} >
                {hiringCheckListData?.emailIDCreation == false ? "No " : "Yes"}
              </span>
            </div>
          </div>
          <div
            className="hiring-questions-main"
            // style={{ borderBottom: "none" }}
          >
            <div className="hiring-questions pt-3 pb-3">Employee Code</div>
            <div className="questions-toggle pt-3 pb-3">
              <ToggleSwitch
                handleToggleChange={() => handleToggleAllItems("employeeCode")}
                name={"employeeCode"}
                isChecked={hiringCheckListData?.employeeCode}
              />
              <span style={{width:'24px'}}>
                {hiringCheckListData?.employeeCode == false ? "No " : "Yes"}
              </span>
            </div>
          </div>
          {/* Attach Offer Letter */}
          <div
            className="hiring-questions-main"
            style={{ borderBottom: "none" }}
          >
            <div className="hiring-questions pt-3 pb-3">Attachment</div>
              <HiringCheckListAttachmentUpload
                uploadFiles={uploadFiles}
                files={files}
                handleDeleteUploadedFile={handleDeleteUploadedFile}
                uploadFetching={uploadFetching}
                handleFileChange={handleFileChange}
                fileInputRef={fileInputRef}
                handleFileClick={handleFileClick}

              />
        
          </div>
        </div>
      </div>
    </>
  );
};

export default CandidateData;
